<template>
  <el-main>
    <!-- data1 add btn -->
    <el-button type="primary" @click="data1.addForm1.dialogVisible = true"
      >+ 照片</el-button
    >
    <!-- 間隔 -->
    <br /><br />
    <!-- data1 table -->
    <el-table :data="data1.data" style="width: 100%">
      <el-table-column label="編號">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="照片">
        <template slot-scope="scope">
          <el-image
            fit="contain"
            style="width: 130px; height: 130px"
            :src="scope.row.pictureUrl"
            :preview-src-list="[scope.row.pictureUrl]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button @click="data1UpdateForm1DialogOpen(scope.$index)"
            >編輯</el-button
          >
          <el-button @click="data1Delete(scope.$index)">刪除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- data1 add dialog -->
    <el-dialog
      title="新增"
      :visible.sync="data1.addForm1.dialogVisible"
      width="30%"
      @closed="data1AddForm1DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data1.addForm1.data"
        status-icon
        :rules="data1.addForm1.rules"
        ref="data1AddForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.addForm1.loading"
      >
        <el-form-item label="照片" prop="picture">
          <PictureUploader
            :fileQuantityLimit="1"
            :fileList.sync="data1.addForm1.data.picture"
            pictureSizeRemark="寬920px"
          ></PictureUploader>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert
            v-show="data1.addForm1.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.addForm1.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm1.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data1AddForm1Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- data1 update dialog -->
    <el-dialog
      title="編輯"
      :visible.sync="data1.updateForm1.dialogVisible"
      width="30%"
      @closed="data1UpdateForm1DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data1.updateForm1.data"
        status-icon
        :rules="data1.updateForm1.rules"
        ref="data1UpdateForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.updateForm1.loading"
      >
        <el-form-item label="照片" prop="picture">
          <PictureUploader
            :fileQuantityLimit="1"
            :fileList.sync="data1.updateForm1.data.picture"
            pictureSizeRemark="寬920px"
          ></PictureUploader>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert
            v-show="data1.updateForm1.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.updateForm1.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.updateForm1.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data1UpdateForm1Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  B_HonorSystem_Rank_Year_Add,
  B_HonorSystem_Rank_Year_GetList,
  B_HonorSystem_Rank_Year_Update,
  B_HonorSystem_Rank_Year_Delete,
} from '@/assets/js/api';
import PictureUploader from '@/components/PictureUploader.vue';

export default {
  data() {
    return {
      data1: {
        data: [],
        addForm1: {
          dialogVisible: false,
          loading: false,
          formRef: 'data1AddForm1',
          errorMessage: '',
          data: {
            picture: [],
          },
          rules: {
            picture: [{ required: true, message: '請上傳檔案' }],
          },
        },
        updateForm1: {
          updateId: 0,
          dialogVisible: false,
          loading: false,
          formRef: 'data1UpdateForm1',
          errorMessage: '',
          data: {
            picture: [],
          },
          rules: {
            picture: [{ required: true, message: '請上傳檔案' }],
          },
        },
      },
    };
  },
  components: {
    PictureUploader,
  },
  mounted() {
    this.data1GetList();
  },
  methods: {
    // data1 get list
    data1GetList() {
      B_HonorSystem_Rank_Year_GetList(this.B_HonorSystem_Rank_Month_Type)
        .then((res) => {
          this.data1.data = res.data.data;
        })
        .catch((err) => {
          this.$notify.error({
            title: '錯誤',
            message: err.response.data.message,
          });
        });
    },
    // data1 add
    data1AddForm1DialogClosed() {
      this.data1.addForm1.loading = false;
      this.$refs[this.data1.addForm1.formRef].resetFields();
      this.data1.addForm1.errorMessage = '';
    },
    data1AddForm1Submit() {
      this.$refs[this.data1.addForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.addForm1.loading = true;
          this.data1.addForm1.errorMessage = '';
          const fd = new FormData();
          fd.append('picture', this.data1.addForm1.data.picture[0].raw);
          B_HonorSystem_Rank_Year_Add(fd)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
              });
              this.data1.addForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.addForm1.loading = false;
              this.data1.addForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 update
    data1UpdateForm1DialogOpen(index) {
      const thisData = this.data1.data[index];
      this.data1.updateForm1.updateId = this.data1.data[index].id;
      this.data1.updateForm1.dialogVisible = true;
      this.data1.updateForm1.data.picture = [
        {
          url: thisData.pictureUrl,
          originalPicture: true,
        },
      ];
    },
    data1UpdateForm1DialogClosed() {
      this.data1.updateForm1.loading = false;
      this.$refs[this.data1.updateForm1.formRef].resetFields();
      this.data1.updateForm1.updateId = 0;
      this.data1.updateForm1.errorMessage = '';
    },
    data1UpdateForm1Submit() {
      this.$refs[this.data1.updateForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.updateForm1.errorMessage = '';
          this.data1.updateForm1.loading = true;
          const fd = new FormData();
          const checkPicture = this.data1.updateForm1.data.picture[0] !== undefined
            && this.data1.updateForm1.data.picture[0].originalPicture !== true;
          if (checkPicture) {
            fd.append('picture', this.data1.updateForm1.data.picture[0].raw);
          }

          B_HonorSystem_Rank_Year_Update(this.data1.updateForm1.updateId, fd)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
              });
              this.data1.updateForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.updateForm1.loading = false;
              this.data1.updateForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 delete
    data1Delete(index) {
      this.$confirm('確定刪除?', '確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          B_HonorSystem_Rank_Year_Delete(this.data1.data[index].id)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
              });
              this.data1GetList();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: 'warning',
              });
            });
        })
        .catch(() => {});
    },
  },
};
</script>
